import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_TASKDETAIL,
  DELETE_TASKDETAIL,
  UPDATE_TASKDETAIL,
  ADD_NEW_TASKDETAIL,
} from "./actionType";

import {
  getTaskDetailSuccess,
  getTaskDetailFail,
  deleteTaskDetailSuccess,
  deleteTaskDetailFail,
  updateTaskDetailSuccess,
  updateTaskDetailFail,
  addTaskDetailSuccess,
  addTaskDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getTaskDetailApi,
  updateTaskDetailApi,
  deleteTaskDetailApi,
  addNewTaskDetailApi
} from "../../helpers/backend_helper";

function* getTaskDetail({ payload: taskDetail }) {
  try {
    const response = yield call(getTaskDetailApi, taskDetail);
    yield put(getTaskDetailSuccess(GET_TASKDETAIL, response.data));
  } catch (error) {
    yield put(getTaskDetailFail(GET_TASKDETAIL, error));
  }
}

function* onUpdateTaskDetail({ payload: taskDetail }) {
  try {
    const response = yield call(updateTaskDetailApi, taskDetail);
    yield put(updateTaskDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateTaskDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteTaskDetail({ payload: taskDetail }) {
  try {
    const response = yield call(deleteTaskDetailApi, taskDetail);
    yield put(deleteTaskDetailSuccess({ taskDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteTaskDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewTaskDetail({ payload: taskDetail }) {
  try {
    const response = yield call(addNewTaskDetailApi, taskDetail);
    yield put(addTaskDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addTaskDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetTaskDetail() {
  yield takeEvery(GET_TASKDETAIL, getTaskDetail);
}

export function* watchUpdateTaskDetail() {
  yield takeEvery(UPDATE_TASKDETAIL, onUpdateTaskDetail);
}

export function* watchDeleteTaskDetail() {
  yield takeEvery(DELETE_TASKDETAIL, onDeleteTaskDetail);
}

export function* watchAddNewTaskDetail() {
  yield takeEvery(ADD_NEW_TASKDETAIL, onAddNewTaskDetail);
}

function* taskDetailSaga() {
  yield all([
    fork(watchGetTaskDetail),
    fork(watchDeleteTaskDetail),
    fork(watchUpdateTaskDetail),
    fork(watchAddNewTaskDetail)
  ]);
}

export default taskDetailSaga;
